import { createFileRoute } from '@tanstack/react-router'
import { VisitorDetailsIPAddressesPage } from 'features/visitorDetails'

export const Route = createFileRoute(
  '/_authenticated/_layout/workspaces/$subscriptionId/visitors/$visitorId/ip-addresses'
)({
  component: VisitorDetailsIPAddressesPage,
})
